export default "__VITE_ASSET__2c6d47bc__"